import Vue from 'vue';

import intersect from '@/js/directives/intersect';

import Header from '@/components/_liferay/Header';

// Mobile Menu
import MenuDesktop from '@/components/navigation/MenuDesktop';
import MenuMobile from '@/components/navigation/MenuMobile';
import MenuContainer from '@/components/navigation/MenuContainer';

// Tabs
import TabsContainer from '@/components/tabs/TabsContainer';
import TabsContainerTablist from '@/components/tabs/TabsContainerTablist';
import TabsContainerTabpanel from '@/components/tabs/TabsContainerTabpanel';
import TabsContainerTablistTab from '@/components/tabs/TabsContainerTablistTab';

// Dependecies
require('intersection-observer');


// Mobile Menu
Vue.component('MenuDesktop', MenuDesktop);
Vue.component('MenuMobile', MenuMobile);
Vue.component('MenuContainer', MenuContainer);

// Tabs
Vue.component('TabsContainer', TabsContainer);
Vue.component('TabsContainerTablist', TabsContainerTablist);
Vue.component('TabsContainerTabpanel', TabsContainerTabpanel);
Vue.component('TabsContainerTablistTab', TabsContainerTablistTab);


/* eslint-disable no-new */
window.udheader = new Vue(Header).$mount('#porch-header');


// WEBPACK FOOTER //
// ./src/js/_liferay/header.js